import { useEffect, useRef } from "react";

const brandsRow1 = [
  { name: "Discord", logo: "https://www.datocms-assets.com/166003/1755458576-discord-icon-1.svg" },
  { name: "PayPal", logo: "https://www.datocms-assets.com/166003/1758543241-logo-paypal.png?h=100&w=100" },
  { name: "Walmart", logo: "https://www.datocms-assets.com/166003/1758633618-logo-walmart.png?h=100&w=100" },
  { name: "Moët & Chandon", logo: "https://www.datocms-assets.com/166003/1758633714-logo-moet-chandon.png?h=100&w=100" },
  { name: "Coinbase", logo: "https://www.datocms-assets.com/166003/1758633775-logo-coinbase.png?h=100&w=100" },
  { name: "Airbnb", logo: "https://www.datocms-assets.com/166003/1758633823-logo-airbnb.png?h=100&w=100" },
  { name: "Amazon", logo: "https://www.datocms-assets.com/166003/1758543222-logo-amazon.svg" },
  { name: "WhatsApp", logo: "https://www.datocms-assets.com/166003/1758633590-logo-whatsapp.png?h=100&w=100" },
];

const brandsRow2 = [
  { name: "Google", logo: "https://www.datocms-assets.com/166003/1758542873-logo-google.png?h=100&w=100" },
  { name: "YouTube", logo: "https://www.datocms-assets.com/166003/1758633552-logo-youtube.png?h=100&w=100" },
  { name: "Uber", logo: "https://www.datocms-assets.com/166003/1758633638-logo-uber.png?h=100&w=100" },
  { name: "Meta", logo: "https://www.datocms-assets.com/166003/1758633737-logo-meta.png?h=100&w=100" },
  { name: "NielsenIQ", logo: "https://www.datocms-assets.com/166003/1758633680-logo-nielseniq.png?h=100&w=100" },
  { name: "HP", logo: "https://www.datocms-assets.com/166003/1758633756-logo-hp.png?h=100&w=100" },
  { name: "Starbucks", logo: "https://www.datocms-assets.com/166003/1763478625-starbucks-edited.png?h=100&w=100" },
  { name: "American Express", logo: "https://www.datocms-assets.com/166003/1763465938-american-express.png?h=100&w=100" },
];

const CARD_WIDTH = 160;
const CARD_GAP = 16;
const UNIT = CARD_WIDTH + CARD_GAP;

function MarqueeRow({
  brands,
  reverse = false,
  duration = 32,
}: {
  brands: typeof brandsRow1;
  reverse?: boolean;
  duration?: number;
}) {
  const styleId = useRef(`marquee-${Math.random().toString(36).slice(2)}`);

  useEffect(() => {
    const id = styleId.current;
    const totalWidth = brands.length * UNIT;
    const keyframes = reverse
      ? `@keyframes ${id} { from { transform: translateX(-${totalWidth}px); } to { transform: translateX(0px); } }`
      : `@keyframes ${id} { from { transform: translateX(0px); } to { transform: translateX(-${totalWidth}px); } }`;

    const style = document.createElement("style");
    style.id = id;
    style.textContent = keyframes;
    document.head.appendChild(style);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [brands.length, reverse]);

  // Duplicate enough times so the track is always wider than the viewport
  const repeated = [...brands, ...brands, ...brands];

  return (
    <div className="overflow-hidden py-3" style={{ maskImage: "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)", WebkitMaskImage: "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)" }}>
      <div
        style={{
          display: "flex",
          gap: `${CARD_GAP}px`,
          width: "max-content",
          animation: `${styleId.current} ${duration}s linear infinite`,
          willChange: "transform",
        }}
      >
        {repeated.map((brand, i) => (
          <div
            key={`${brand.name}-${i}`}
            style={{ minWidth: `${CARD_WIDTH}px` }}
            className="flex flex-col items-center gap-2 bg-white rounded-xl px-5 py-4 cursor-pointer hover:scale-105 transition-transform duration-200"
          >
            <div className="w-12 h-12 flex items-center justify-center">
              <img
                src={brand.logo}
                alt={brand.name}
                className="max-w-full max-h-full object-contain"
                loading="lazy"
              />
            </div>
            <span className="text-xs font-medium text-gray-600 whitespace-nowrap">{brand.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function BrandsSection() {
  return (
    <section className="pb-20 px-0" style={{ backgroundColor: "#FEF7EB" }}>
      <div className="max-w-7xl mx-auto px-6 md:px-16 mb-10 pt-20">
        <p className="text-xs font-semibold uppercase tracking-widest mb-3" style={{ color: "#0073E5" }}>
          In Good Company
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-black">Names that trust London App Syndicate LTD</h2>
      </div>
      <div className="space-y-2">
        <MarqueeRow brands={brandsRow1} reverse={false} duration={36} />
        <MarqueeRow brands={brandsRow2} reverse={true} duration={40} />
      </div>
    </section>
  );
}
